import { Box } from 'grommet'
import styled from 'styled-components'

const darkColor = (props) => props.theme.global.colors['dark-2']
const lightColor = (props) => props.theme.global.colors['white']
const linkColor = (props) => props.theme.global.colors['blueLink']
const primaryColor = (props) => props.theme.global.colors['primary']

export const ModalContainer = styled(Box)`
  background-color: ${lightColor};
  padding: 24px;
  max-width: 504px;
  width: 100%;
  margin: 0 auto;
  border-radius: 4px;

  @media screen and (max-width: 768px) {
    padding: 16px;
  }

  @media screen and (max-width: 485px) {
    width: calc(100% - 24px);
  }
`

export const HeadingSection = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 8px;
`

export const Heading = styled.h1`
  font-size: 24px;
  font-weight: 500;
  color: ${darkColor};
  line-height: 150%;
  margin: 0;

  @media screen and (max-width: 768px) {
    font-size: 20px;
  }
`

export const SubHeading = styled.h5`
  font-size: 16px;
  font-weight: 400;
  color: ${darkColor};
  letter-spacing: 0.25px;
  line-height: 165%;
  margin: 0 0 16px;
  display: flex;
  flex-direction: column;
  gap: 20px;

  @media screen and (max-width: 768px) {
    font-size: 14px;
  }
`

export const CTAWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`

export const CloseCTA = styled.button`
  background-color: transparent;
  border: none;
  cursor: pointer;
  display: flex;
  justify-content: flex-end;
  padding: 0;
`

export const CancelCTA = styled.button`
  background-color: ${primaryColor};
  border: none;
  color: ${darkColor};
  font-family: 'Roboto';
  font-size: 14px;
  font-weight: 600;
  border-radius: 4px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  padding: 0 24px;
  line-height: 165%;
  cursor: pointer;
`

export const ContinueCTA = styled.button`
  background-color: transparent;
  border: none;
  color: ${linkColor};
  font-family: 'Roboto';
  font-size: 14px;
  font-weight: 400;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  padding: 0 24px;
  line-height: 165%;
  cursor: pointer;
  text-decoration: underline;
`